import { createEntityAdapter } from '@reduxjs/toolkit';
import { StageV2 } from '../../domain/interfaces/stage';

const stagesAdapter = createEntityAdapter<StageV2>({
  selectId: (stage) => stage.id,
  sortComparer: (a, b) => a.createdAt.valueOf() - b.createdAt.valueOf(),
});

export default stagesAdapter;
